<style scoped lang="scss">

</style>

<template>
<div class="uk-form" v-if="application && application.household">
    <div class="uk-grid" v-if="!print">
        <div class="uk-width-medium-3-5 uk-push-1-5 uk-margin-large-bottom">
            <div class="uk-panel-box"><strong>Understanding Gross vs Net:</strong> <small><br class="uk-margin-bottom"/>
                Gross income is the amount you earn before deductions are subtracted for insurance, taxes, Medicare, fees etc.. Net income is how much money is left after the deductions are subtracted. For this application, please enter your gross income for ALL income types.</small>
            </div>
        </div>
    </div>

    <div class="uk-grid">
        <div class="uk-width-1-1 " v-if="householdMembersWithIncome" v-for="member in household.members" :key="member.id" v-show="ageForMember(member) >= 18">
            <legend>{{ member.first_name }} {{ member.last_name }}</legend>
            <div class="uk-grid" v-if="householdMembersWithIncome[member.id]">
                <div class="uk-width-medium-1-4 uk-margin-large-bottom">
                    <label>
                        <input type="radio" v-model="householdMembersWithIncome[member.id].hasIncome"  @change="checkboxUpdated" :value="true"/>
                        {{ member.first_name }} {{ member.last_name }} has income to report.
                    </label>
                </div>
                <div class="uk-width-medium-3-4 uk-margin-bottom">
                    <label>
                        <input type="radio" v-model="householdMembersWithIncome[member.id].hasIncome" @change="checkboxUpdated"  :value="false"/>
                        I certify that {{ member.first_name }} {{ member.last_name }}  has no income of any kind.
                    </label>
                </div>
                <div class="uk-width-8-10 uk-align-center" v-if="householdMembersWithIncome[member.id].hasIncome">
                    <income-entry-form @updated="onMemberIncomeChanged" :values="householdMembersWithIncome[member.id].incomeValues" :member="member" :label="member.first_name + ' ' + member.last_name"></income-entry-form>
                </div>
            </div>


        </div>
        <div class="uk-width-1-1">
            <div class="uk-grid" v-if="!hasHouseholdEarners">
                <div class="uk-width-1-1">
                    <p>
                        If you declare that no one in your household receives a source of income you must provide a
                        statement on how you meet your MONTHLY living expenses:
                    </p>
                </div>
                <div class="uk-width-1-1">
                    <table class="uk-table uk-hidden-small uk-table-striped">
                        <thead>
                        <tr>
                            <th>Monthly Expense</th>
                            <th>Monthly Amount</th>
                            <th>How does it get paid?</th>
                            <th>Who pays it?</th>
                            <th>Contact Phone</th>
                            <th>Contact Email</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="incomeValue in zeroIncomeValues">
                            <td>{{ incomeValue.label }}</td>
                            <td>
                                <vue-numeric currency="$" v-model="incomeValue.amount" type="text"></vue-numeric>
                            </td>
                            <td>
                                <select v-model="incomeValue.method" placeholder="Select a method" class="uk-select">
                                    <option :value="null">Select a method</option>
                                    <option v-for="(label, value) in zeroIncomePaymentMethods" :value="value">{{ label }}</option>
                                </select>
                            </td>
                            <td>
                                <input type="text" v-model="incomeValue.payer">
                            </td>
                            <td>
                                <input type="text" v-model="incomeValue.payer_phone">
                            </td>
                            <td>
                                <input type="text" v-model="incomeValue.payer_email">
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="uk-grid uk-width-small-1-1 uk-hidden-medium uk-hidden-large uk-form uk-form-horizontal uk-form-stacked" v-for="incomeValue in zeroIncomeValues">
                        <div class="uk-width-1-1">
                            <h4>
                                {{ incomeValue.label }}
                            </h4>
                        </div>
                        <div class="uk-width-1-2 uk-margin-top uk-margin-bottom">
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">Monthly Amount</label>
                                <div class="uk-form-controls">
                                    <div>
                                        <vue-numeric currency="$" v-model="incomeValue.amount" type="text"></vue-numeric>
                                    </div>
                                </div>
                            </div>
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">Who pays it?</label>
                                <div class="uk-form-controls">
                                    <div>
                                        <input type="text" v-model="incomeValue.payer">
                                    </div>
                                </div>
                            </div>
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">Contact Phone</label>
                                <div class="uk-form-controls">
                                    <div>
                                        <input type="text" v-model="incomeValue.payer_phone">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="uk-width-1-2 uk-margin-top uk-margin-large-bottom">
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">How?</label>
                                <div class="uk-form-controls">
                                    <select v-model="incomeValue.method" placeholder="Select a method" class="uk-select">
                                        <option :value="null">Select a method</option>
                                        <option v-for="(label, value) in zeroIncomePaymentMethods" :value="value">{{ label }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">Contact Email</label>
                                <div class="uk-form-controls">
                                    <div>
                                        <input type="text" v-model="incomeValue.payer_email">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="uk-width-1-1 uk-margin-large-top">
            <h2 class="uk-text-right">Total Annualized Household Income: {{ getTotalRequested() | formatMoney }}</h2>
        </div>
    </div>
</div>
</template>

<script>
    import IncomeEntryForm from "../../../../../components/AppWizard/Step3/IncomeEntryForm";
    import { mapState } from 'vuex';

    export default {
        name: "Step3",
        components: {IncomeEntryForm},
        props: {
            print: {
                default: false,
            }
        },
        data() {
            return {
                primaryApplicantHasIncome: false,
                primaryApplicantIncomeValues: [],
                householdMembersWithIncome: null,
                zeroIncomePaymentMethods: {
                    gift: 'Gift',
                    loan: 'Loan',
                    other: 'Other',
                },
                zeroIncomeValues: [
                    {
                        name: 'housing',
                        label: 'Housing',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'utilities',
                        label: 'Utilities',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'food',
                        label: 'Food',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'transportation',
                        label: 'Transportation',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'phone',
                        label: 'Cell Phone',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'personal',
                        label: 'Personal Expenses',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'other',
                        label: 'Other Expenses',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                ],
            }
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        computed: {
            hasHouseholdEarners() {
                let hasEarners = false;
                if(this.primaryApplicantHasIncome) {
                    hasEarners = true;
                }
                for(let i in this.householdMembersWithIncome) {
                    let member = this.householdMembersWithIncome[i];
                    console.log(member);
                    if(member.hasIncome) {
                        hasEarners = true;
                    }
                }
                return hasEarners;
            },
            household() {
                if(this.application && this.application.household) {
                    return this.application.household;
                }
            },
            ...mapState('Application', {
                application: state => state.application,
            }),
        },
        mounted() {
            if(this.household) {
                this.initData();
            }
        },
        methods: {
            initData() {
                this.generateMembersArray();

                _.each(this.application.zero_income_meta, meta => {
                    _.each(this.zeroIncomeValues, value => {
                        if(meta.name === value.name) {
                            value.amount = meta.amount;
                            value.method = meta.method;
                            value.payer = meta.payer;
                            value.payer_phone = meta.payer_phone;
                            value.payer_email = meta.payer_email;
                        }
                    })
                })
            },

            generateMembersArray() {
                this.$set(this, 'householdMembersWithIncome', {});

                _.each(this.household.members, member => {
                    // get age
                    let dob = moment(member.birth_date);
                    let age = moment().diff(dob, 'years');
                    if(age < 18) return;

                    this.$set(this.householdMembersWithIncome, member.id, {
                        hasIncome: member.annual_income !== null && member.annual_income > 0,
                        incomeValues: member.annual_income_meta,
                    });
                })
            },
            async validateStep() {
                let isValid = false;

                // Local Validation
                try {
                    let result = await this.save();
                    return true;
                }catch(err) {
                    return false;
                }

            },
            save() {

                let data = {
                    application: {
                        zero_income: this.hasHouseholdEarners ? 0 : 1,
                        zero_income_meta: (this.hasHouseholdEarners) ? null : JSON.stringify(this.zeroIncomeValues),
                    },
                    members: this.getHouseholdMemberData(),
                }

                return axios.put(`/api/hope/applications/${this.application.id}/step-3-1`, data);
            },
            getHouseholdMemberData() {
                let data = {}
                _.each(this.householdMembersWithIncome, (member, id) => {
                    data[id] = {
                        annual_income: this.getTotalRequestedForMember(member),
                        annual_income_meta: member.incomeValues,
                    }
                })
                return data;
            },

            ageForMember(member) {
                return moment().diff(moment(member.birth_date), 'years');
            },
            checkboxUpdated() {
                window.setTimeout(() => this.$forceUpdate(), 200);
                // this.$nextTick(this.$forceUpdate);
            },

            getTotalRequestedForMember(member) {
                let total = 0;
                _.each(member.incomeValues, value => {
                    total += this.getAnnualIncomeFromIncomeValue(value)
                })
                return total;
            },
            getTotalRequested() {
                let total = 0;
                if(this.primaryApplicantHasIncome) {
                    _.each(this.primaryApplicantIncomeValues, value => {
                        total += this.getAnnualIncomeFromIncomeValue(value)
                    })
                }

                _.each(this.householdMembersWithIncome, member => {
                    if(member.hasIncome) {
                        total += this.getTotalRequestedForMember(member);
                    }

                })
                return total;
            },
            getAnnualIncomeFromIncomeValue(value) {
                let amount;
                switch(value.interval) {

                    case 'monthly':
                    case 'other':
                        amount = value.amount * 12;
                        break;

                    case 'weekly':
                        amount = value.amount * 52;
                        break;

                    case 'biweekly':
                        amount = value.amount * 26;
                        break;

                    case 'bimonthly':
                        amount = value.amount * 24;
                        break;

                    case 'annually':
                        amount = value.amount;
                        break;

                    default: amount = value.amount * 12;
                }
                return amount;
            },
            onMemberIncomeChanged($event) {
                this.householdMembersWithIncome[$event.member.id]['incomeValues'] = $event.amounts;
                this.$nextTick(this.$forceUpdate);
            },
            onApplicantIncomeChanged($event) {
                this.primaryApplicantIncomeValues = $event.amounts;
                this.$nextTick(this.$forceUpdate);
            },
            MonthlyTotalIncome() {
                var totalMonthlyIncome = 0;
                var monthlyGrossWagesPrimaryJob = parseInt($('#financial-information-form').find('input[name="monthly-gross-wages-primary-job"]').val());
                /// ADD IN VARS DYNAMICALLY FOR EACH APPLICANT ADDED ON SECTION 2 FOR GRAND TOTAL ///

                var monthlyGrossWagesSecondJob = parseInt($('#financial-information-form').find('input[name="monthly-gross-wages-second-job"]').val());
                var monthlyGrossWagesThirdJob = parseInt($('#financial-information-form').find('input[name="monthly-gross-wages-third-job"]').val());
                var selfEmployment = parseInt($('#financial-information-form').find('input[name="self-employment"]').val());
                var alimony = parseInt($('#financial-information-form').find('input[name="alimony"]').val());
                var socialSecurityIncome = parseInt($('#financial-information-form').find('input[name="social-security-income"]').val());
                var socialSecurityDisability = parseInt($('#financial-information-form').find('input[name="social-security-disability"]').val());
                var unemploymentCompensation = parseInt($('#financial-information-form').find('input[name="unemployment-compensation"]').val());
                var otherGovernmentAssistance = parseInt($('#financial-information-form').find('input[name="other-government-assistance"]').val());
                var retirement = parseInt($('#financial-information-form').find('input[name="retirement"]').val());
                var annuityInvestment = parseInt($('#financial-information-form').find('input[name="annuity-investment"]').val());
                var rentFromRoommate = parseInt($('#financial-information-form').find('input[name="rent-from-roommate"]').val());
                var rentalPropertyIncome = parseInt($('#financial-information-form').find('input[name="rental-property-income"]').val());
                var contributionsFromFamilyOrFriends = parseInt($('#financial-information-form').find('input[name="contributions-from-family-or-friends"]').val());
                var other = parseInt($('#financial-information-form').find('input[name="other"]').val());
                totalMonthlyIncome = monthlyGrossWagesPrimaryJob + monthlyGrossWagesSecondJob + monthlyGrossWagesThirdJob + selfEmployment + alimony + socialSecurityIncome + socialSecurityDisability + unemploymentCompensation + otherGovernmentAssistance + retirement + annuityInvestment + rentFromRoommate + rentalPropertyIncome + contributionsFromFamilyOrFriends + other;
                $('#financial-information-form').find('input[name="total-monthly-income"]').val(totalMonthlyIncome);

            }
        }
    }
</script>
